import React from "react";
import { aroma, fuss, fussbad, gesichtsbehandlung, hotstone, manicure, placeholder, tiefgewebe } from "../utils"; // Ensure this points to your actual image
import Footer from "../components/Footer";

const Services = () => {
  const services = [
    {
      title: "Maniküre",
      description:
        "Pflege und Verschönerung Ihrer Hände, Nägel und Nagelhaut für ein makelloses Erscheinungsbild.",
      img: manicure,
    },
    {
      title: "Pediküre",
      description:
        "Professionelle Fußpflege für gesunde, gepflegte Füße und schöne Nägel.",
      img: fussbad,
    },
    {
      title: "Gesichtsbehandlung",
      description:
        "Individuell abgestimmte Pflege für ein strahlendes Hautbild – reinigt, belebt und verwöhnt Ihre Haut nachhaltig.",
        img: gesichtsbehandlung,
      },
    {
      title: "Tiefengewebsmassage",
      description:
        "Intensive Massage zur Linderung von Muskelverspannungen und zur Förderung der Regeneration.",
      img: tiefgewebe,
      },
    {
      title: "Hot-Stone Massage",
      description:
        "Erleben Sie tiefgehende Entspannung durch die wohltuende Wärme von Steinen.",
      img: hotstone,
      },
    {
      title: "Aromatherapie-Massage",
      description:
        "Massage kombiniert mit duftenden ätherischen Ölen für eine ganzheitliche Entspannung.",
      img: aroma,
      },
  ];

  return (
    <div className="min-h-screen bg-black text-black py-20 px-8">
      {/* Header Section */}
      <div className="max-w-7xl mx-auto text-center mb-16 mt-16">
        <h1 className="text-5xl font-extrabold mb-4 text-white">
          Unsere Dienstleistungen
        </h1>
        <p className="text-xl text-white">
          Erleben Sie eine Welt voller Schönheit und Entspannung mit unseren
          exklusiven Services.
        </p>
      </div>

      {/* Services Grid: 1 Column on small screens, 2 columns on medium+ */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
        {services.map((service, index) => (
          <div
            key={index}
            className="bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300"
          >
            <h2 className="text-2xl font-bold mb-2">{service.title}</h2>
            <p className="text-gray-600 mb-8">{service.description}</p>
            <img
              src={service.img}
              alt={service.title}
              className="w-full h-auto object-cover rounded-md mb-4"
            />
          </div>
        ))}
      </div>
      <Footer/>
    </div>
  );
};

export default Services;
